import Resource from '../../../api/resources/Resource'

class RegistryRequestResource extends Resource {
    async paginator(filterModel, params, laboratoryId) {
        // TODO: backend needs to change this paginator to PUT method
        const response =
            await this.axios.get(
                `/registry/laboratories/${laboratoryId}/requests`,
                {
                    params: {
                        ...params,
                        filterModel
                    }
                })
        return response.data
    }

    getRequest(labId, requestId) {
        return this.axios.get(`/registry/laboratories/${labId}/requests/${requestId}`)
    }

    async getSubRequests(labId, requestId) {
        const response = await this.axios.get(`/registry/laboratories/${labId}/requests/${requestId}/subrequests`)
        return response.data
    }

    processRequest(labId, requestId, caseLabel) {
        const params = {
            caseLabel
        }
        return this.axios.put(`/registry/laboratories/${labId}/requests/${requestId}/process`, null, { params })
    }

    cancelRequest(labId, requestId) {
        return this.axios.put(`/registry/laboratories/${labId}/requests/${requestId}/cancel`)
    }

    blockRequest(labId, requestId) {
        return this.axios.put(`/registry/laboratories/${labId}/requests/${requestId}/lock`)
    }
    returnRequest(params) {
        return this.axios.put(`/registry/laboratories/requests/return`, params)
    }

    async requestsSummary(labId) {
        return this.axios.get(`/registry/laboratories/${labId}/requests/summary`).then(response => response.data)
    }

    async searchByRequestLabel(labId, params) {
        return this.axios.get(`/registry/laboratories/${labId}/requests/searchByRequestLabel`, { params }).then(response => response.data)
    }

    async searchBySubrequestLabel(laboratoryId, params) {
        return this.axios.get(`/registry/laboratories/${laboratoryId}/requests/searchBySubrequestLabel`, { params }).then(response => response.data)
    }

    async bringToLaboratory(laboratoryId, requestId) {
        return this.axios.put(`/registry/laboratories/${laboratoryId}/requests/${requestId}/bringToLaboratory`)
    }
}

export default new RegistryRequestResource()
